// extracted by mini-css-extract-plugin
export default {"nav":"NavClanProfile_nav_ba11d","link":"NavClanProfile_link_c1858","linkCurrent":"NavClanProfile_linkCurrent_dc715","title":"NavClanProfile_title_f4560"};